import { CellClassParams, ValueGetterParams } from 'ag-grid-community';
import { RateMultiplierDisplayName } from 'src/constants';

import { validateRequired } from '../validationsUtil';

export const getDealStatusCellStyle = (params: ValueGetterParams) => {
    switch (params.data.deal_status) {
        case 'New':
        case 'Updated':
            return { fontWeight: 600 };
        case 'Canceled':
            return { textDecoration: 'line-through' };
        default:
            return {};
    }
};

export const getDerivedRateValueCellStyle = (params: ValueGetterParams) => {
    // @ts-ignore
    return params.colDef.isCppPlan ? {} : { color: '#697576', fontStyle: 'italic' };
};

export const getCustomMultiplierCellStyle = (params: CellClassParams) => {
    if (
        !validateRequired(params.value?.toString()) &&
        params.data.multiplierName === RateMultiplierDisplayName.CUSTOM
    ) {
        return { backgroundColor: '#F9D5E2' };
    }
    return null;
};
